<div class="att-page">
    <section class="card-plain">
        <div class="filter-grid">
            <app-select-academic-year-only
                (academicYearChanged)="onChangeAcademicYear($event); clearData()"
                [group_by_period]="true"
                [all_academic_year]="true">
            </app-select-academic-year-only>
            <app-select-school-level-relation-v2
                [academic_year]="this.paramForm.get('academic_year')?.value"
                [period_id]="this.paramForm.get('period_id')?.value"
                (schoolLevelRelationChanged)="onChangeSchoolLevel($event); clearData()"
                [task]="'SCHOOL_PROGRAM_ATTENDANCE_VIEW'"
                [useSupervisorAccess]="true"
                [supervisorLocationAccess]="this.supervisorLocationAccess">
            </app-select-school-level-relation-v2>
            <app-select-school-program
                [academic_year]="this.paramForm.get('academic_year')?.value"
                [school_location_id]="this.paramForm.get('school_location_id')?.value"
                (schoolProgramChanged)="onChangeSchoolProgram($event); clearData()">
            </app-select-school-program>
            <app-select-school-program-category
                [school_program_id]="this.paramForm.get('school_program_id')?.value"
                [all]="true"
                (schoolProgramCategoryChanged)="onChangeSchoolProgramCategory($event); clearData()">
            </app-select-school-program-category>
            <app-select-school-activity
                (schoolActivityChanged)="onChangeSchoolProgramActivity($event); clearData()"
                [academic_year]="this.paramForm.get('academic_year')?.value"
                [school_program_id]="this.paramForm.get('school_program_id')?.value"
                [school_program_category_id]="this.paramForm.get('school_program_category_id')?.value">
            </app-select-school-activity>
        </div>
    </section>

    @if (loading) {
        <app-status-loading [show]="true"></app-status-loading>
    } @else if (!paramForm.get('school_program_activity_id')?.value) {
        <p class="hint">{{ 'Select an activity above to see its sessions and attendance.' | translate }}</p>
    } @else if (!dataSession.length) {
        <app-status-no-data [show]="true"></app-status-no-data>
    } @else {
        <section class="card-plain">
            <h2 class="section-title">{{ 'Overview' | translate }}</h2>
            <div class="stats">
                <div class="stat">
                    <span class="stat__label">{{ 'Attendance rate' | translate }}</span>
                    <span class="stat__value">{{ summary.rate !== null ? summary.rate + '%' : '-' }}</span>
                    @if (summary.rate !== null) {
                        <span class="meter" role="img" [attr.aria-label]="summary.rate + '%'">
                            <span class="meter__fill" [style.width.%]="summary.rate"></span>
                        </span>
                    }
                </div>
                <div class="stat">
                    <span class="stat__label"><span class="dot dot--present"></span>{{ 'Present' | translate }}</span>
                    <span class="stat__value">{{ summary.present | number }}</span>
                </div>
                <div class="stat">
                    <span class="stat__label"><span class="dot dot--absent"></span>{{ 'Absent' | translate }}</span>
                    <span class="stat__value">{{ summary.absent | number }}</span>
                </div>
                <div class="stat">
                    <span class="stat__label">{{ 'Sessions recorded' | translate }}</span>
                    <span class="stat__value">{{ summary.recorded }}<span class="stat__of"> / {{ summary.total }}</span></span>
                </div>
            </div>

            @if (chartSessionCount > 1) {
                <div class="chart-block">
                    <h3 class="chart-title">{{ 'Attendance rate per session' | translate }}</h3>
                    <apx-chart
                        [series]="chartOptions.series"
                        [chart]="chartOptions.chart"
                        [colors]="chartOptions.colors"
                        [plotOptions]="chartOptions.plotOptions"
                        [dataLabels]="chartOptions.dataLabels"
                        [states]="chartOptions.states"
                        [grid]="chartOptions.grid"
                        [xaxis]="chartOptions.xaxis"
                        [yaxis]="chartOptions.yaxis"
                        [annotations]="chartOptions.annotations"
                        [tooltip]="chartOptions.tooltip">
                    </apx-chart>
                </div>
            }
        </section>

        <section class="card-plain card-plain--flush">
            <h2 class="section-title section-title--padded">
                {{ 'Sessions' | translate }}
                @if (activityName) {
                    <span class="section-title__sub">{{ activityName }}</span>
                }
            </h2>
            <table mat-table [dataSource]="dataSession" class="session-table">
                <ng-container matColumnDef="session_date">
                    <th mat-header-cell *matHeaderCellDef>{{ 'Session Date' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="cell-date">
                        {{ element.activity_session_date | date:'EEE, d MMM y' }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>{{ 'Status' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <span class="state" [ngClass]="'state--' + getSessionState(element).tone">
                            <span class="state__dot"></span>{{ getSessionState(element).label | translate }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="present">
                    <th mat-header-cell *matHeaderCellDef class="cell-num">{{ 'Present' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="cell-num">
                        {{ element.attendance_created ? element.present_count : '-' }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="absent">
                    <th mat-header-cell *matHeaderCellDef class="cell-num">{{ 'Absent' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="cell-num">
                        {{ element.attendance_created ? element.absent_count : '-' }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="rate">
                    <th mat-header-cell *matHeaderCellDef class="cell-num">{{ 'Rate' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="cell-num">
                        {{ getSessionRate(element) !== null ? getSessionRate(element) + '%' : '-' }}
                    </td>
                </ng-container>

                @if (auth.permissions['SCHOOL_PROGRAM_ATTENDANCE_CREATE'] || auth.permissions['SCHOOL_PROGRAM_SESSION_EDIT']) {
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="cell-action"><span class="visually-hidden">{{ 'Action' | translate }}</span></th>
                        <td mat-cell *matCellDef="let element" class="cell-action">
                            <div class="row-actions">
                                @if (!element.attendance_created) {
                                    @if (!element.eventday) {
                                        @if (!element.disabled && auth.permissions['SCHOOL_PROGRAM_ATTENDANCE_CREATE']) {
                                            <button type="button" class="action-btn action-btn-create row-btn" (click)="onEntryAttendance(element.activity_session_id, element.activity_session_date)">
                                                {{ 'Entry' | translate }}
                                            </button>
                                        }
                                        @if (!element.disabled && auth.permissions['SCHOOL_PROGRAM_SESSION_EDIT']) {
                                            <button type="button" class="action-btn action-btn-delete row-btn" (click)="onToggleDisableAttendance(element.activity_session_id, true)">
                                                {{ 'Disable' | translate }}
                                            </button>
                                        }
                                        @if (element.disabled && auth.permissions['SCHOOL_PROGRAM_SESSION_EDIT']) {
                                            <button type="button" class="action-btn action-btn-edit row-btn" (click)="onToggleDisableAttendance(element.activity_session_id, false)">
                                                {{ 'Enable' | translate }}
                                            </button>
                                        }
                                    }
                                } @else {
                                    <button type="button" class="action-btn action-btn-edit row-btn" (click)="onViewAttendance(element.activity_session_id, element.activity_session_date)">
                                        {{ (auth.permissions['SCHOOL_PROGRAM_ATTENDANCE_EDIT'] ? 'Edit' : 'View') | translate }}
                                    </button>
                                    @if (!element.disabled && auth.permissions['SCHOOL_PROGRAM_SESSION_EDIT']) {
                                        <button type="button" class="action-btn action-btn-delete row-btn" (click)="onToggleDisableAttendance(element.activity_session_id, true)">
                                            {{ 'Disable' | translate }}
                                        </button>
                                    }
                                    @if (element.disabled && auth.permissions['SCHOOL_PROGRAM_SESSION_EDIT']) {
                                        <button type="button" class="action-btn action-btn-edit row-btn" (click)="onToggleDisableAttendance(element.activity_session_id, false)">
                                            {{ 'Enable' | translate }}
                                        </button>
                                    }
                                }
                            </div>
                        </td>
                    </ng-container>
                }

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" [class.is-disabled]="element.disabled" [class.is-eventday]="element.eventday"></tr>
            </table>
        </section>
    }
</div>
